module.exports = __webpack_public_path__ + "img/postfinance-alternate.82a158c0.png";